import { Navigation } from 'swiper/modules';
import Swiper from 'swiper';

export default function initProductCard() {
  Alpine.data('productCard', (defaultColor: number) => ({
    productColorSwiper: null as Swiper | null,
    selectedColor: defaultColor,
    init() {
      const swiperEl = this.$el.querySelector('.product-color-swiper') as HTMLElement;
      if (swiperEl) {
        this.productColorSwiper = new Swiper(swiperEl, {
          modules: [Navigation],
          loop: true,
          spaceBetween: 11,
          slidesPerView: 'auto',
          navigation: {
            nextEl: `#${this.$el.id} .product-card-color-swiper-button-next`,
            prevEl: `#${this.$el.id} .product-card-color-swiper-button-prev`,
          },
        });
      }
    },
    selectColor(id: number) {
      this.selectedColor = id;
    },
    isColorSelected(id: number) {
      return this.selectedColor === id;
    },
  }));
}
